module.exports = __webpack_public_path__ + "static/media/alugar-imovel-anage.0d6fc677.svg";